import React from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';

import QAmountField from 'components/QAmountField';

import { investmentTransactionEditFormHooks } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';
import { SecurityAndTagsFields } from './SecurityAndTagsFields';
import { numberFromInput } from './utils';

export function BuyBondsFields(): React.JSX.Element {
  const amount = investmentTransactionEditFormHooks.useField('amount');
  const units = investmentTransactionEditFormHooks.useField('units');
  const commission = investmentTransactionEditFormHooks.useField('commission');
  const costBasis = investmentTransactionEditFormHooks.useField('costBasis');
  const pricePerUnit = investmentTransactionEditFormHooks.useField('bondPricePerUnit');
  const accruedInterest = investmentTransactionEditFormHooks.useField('bondAccruedInterest');

  return (
    <>
      <SecurityAndTagsFields />
      <Box display='flex' gap={1}>
        <Box display='flex' flexDirection='column' gap={3}>
          <Box display='flex' alignItems='center' gap={1}>
            <QAmountField
              id='face-value'
              editable
              label='Face value'
              sx={{ minWidth: 110 }}
              noNegatives
              value={Math.abs(units.value ?? 0) * 100}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                units.onValueChange(numberFromInput(event.target.value) / 100)
              }
              error={units.error}
              helperText={units.helperText}
            />
            /
            <Box component='span' whiteSpace='nowrap'>
              100
            </Box>
          </Box>
        </Box>
        <Box display='flex' flexDirection='column' gap={3}>
          <Box display='flex' gap={1} alignItems='center'>
            =
            <TextField
              id='shares'
              label='Shares'
              type='number'
              inputProps={{ min: 1 }}
              sx={{ minWidth: 110 }}
              disabled
              value={Math.abs(units.value ?? 0)}
            />
            *
            <QAmountField
              id='price-per-share'
              editable
              sx={{ minWidth: 110 }}
              label='Price (per $100)'
              noNegatives
              value={pricePerUnit.value ?? undefined}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                pricePerUnit.onValueChange(numberFromInput(event.target.value))
              }
              error={amount.error}
              helperText={amount.helperText}
            />
            +
            <QAmountField
              id='commission'
              editable
              sx={{ minWidth: 110 }}
              value={commission.value ?? undefined}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                commission.onValueChange(numberFromInput(event.target.value))
              }
              label='Commission'
            />
          </Box>
          <Box display='flex' alignItems='center' gap={1}>
            =
            <QAmountField
              id='cost-basis'
              editable
              disabled
              InputProps={{ readOnly: true }}
              sx={{ minWidth: 110 }}
              label='Principal/cost basis'
              value={costBasis.value ?? undefined}
            />
            +
            <QAmountField
              id='accrued-interest'
              editable
              sx={{ minWidth: 110 }}
              label='Accrued interest'
              value={accruedInterest.value}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                accruedInterest.onValueChange(numberFromInput(event.target.value))
              }
            />
          </Box>
          <Divider />
          <Box display='flex' gap={1}>
            =
            <QAmountField
              id='total-amount'
              editable
              disabled
              label='Total amount'
              sx={{ minWidth: 110 }}
              noNegatives
              value={Math.abs(amount.value ?? 0)}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
